import { FORBIDDEN, } from 'http-status-codes';
import { createSelector } from 'reselect';

import { StoreBasicDataApiStructure, } from 'common/types';
import { repositories, } from 'api';
import { PendingData, } from 'store/ducks/pendingData/types';

type MeStateType = {
    me: StoreBasicDataApiStructure<repositories.MeType>,
};

export const hasAccessSelector = (state: MeStateType) => !(state.me.errorCode === FORBIDDEN);
export const isLoggedSelector = (state: MeStateType) => Boolean(state.me.data) || state.me.errorCode === FORBIDDEN;

type InfoType = {
    info: StoreBasicDataApiStructure<repositories.InfoType>,
};

export const getChartToken = ({
    me,
    info
}: MeStateType & InfoType) => me.data?.carts.find(cart => cart.channel === info.data.code)?.token;

const getIsLoadingCartItemsFlag = (pendingData: PendingData) => pendingData.CART_ITEMS_POST;
const getIsLoadingCartsFlag = (pendingData: PendingData) => pendingData.CARTS_POST;

export const getIsLoadingFlagAtAddingItemsToTheCartShop = createSelector(
    getIsLoadingCartItemsFlag,
    getIsLoadingCartsFlag,
    (cartItems, carts) => ({
        cartItems: Boolean(cartItems),
        carts: Boolean(carts),
    })
);

const getMeInfo = (me: StoreBasicDataApiStructure<repositories.MeType>) => me;

export const getInfoAboutAllowingRequestBasedOnValidLogin = createSelector(
    getMeInfo,
    (me) => me.data !== null && !me.isError,
);
